import React from "react";
import InfoComponent from "../InfoComponent";
import SpiderCopy from "../../assets/img/test-img/SpiderCopy.png";
import "./manifesto.css";

const Manifesto = () => {
  return (
    <>
      <div className="manifesto-pad-top">
        {/* <InfoComponent
          titleSm="We rise together"
          titleLg="THE MANIFESTO 
              "
          text="We grow together.
              "
        /> */}
        <div className="container">
        <div>
            <h3 className="manifesto-heading-top">The Manifesto: </h3>
       
          </div>
          <div className="col-md-12 manifesto-main-style">
            
            <div className="col-md-6 manifesto-content-section">
         <p>
         Here comes a new wave…<br/>
And surfing here is different.<br/>
Breaking down barriers.<br/>
Building upon communities.<br/>
Creating magic internet money with our friends.<br/>
To those who don’t get it, we tell them: gm<br/>
They’ll come around eventually.<br/>

         </p>

              <p>Here’s to the ones with the courage to jump down a peculiar rabbit hole.
One the pulls you away from a world that’s created by many and owned by few.
Top a world that’s created by more and owned by all.</p>
              <p>
              We rise together.<br/>
We build together.<br/>
We grow together.<br/>
              </p>
              <p>Ready to part of <b>Meta Street Apes.</b></p>
            </div>
            <div className="col-md-6 manifesto-image-setion">
              <img
                className="manifesto-image-setion-inner"
                src={SpiderCopy}
                alt="captain"
                // width="450px"
                // height="400px"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Manifesto;
